export const acccessConstants = {
    ADMIN: 'ADMIN',
    USER: 'USER',
    ALL: 'ALL'
};
